<script lang="ts">
  import JobCarouselItem from '$lib/ui/JobCarouselItem.svelte';
  import { profile } from 'shared-lib/stores/store';
  import { Grid } from 'carbon-components-svelte';
  export let data: any;
  import { pageDescription, pageName } from 'shared-lib/stores/store';
  pageName.set(`Benefits : ${data?.value?.name} : Jobs`);
  pageDescription.set(
    `All the jobs below are listed as offering "${data?.value?.name}". The benefit keywords, and the company's listed benefits, are used to match candidate values to these keywords`
  );
</script>

<Grid class="dashboard-header-tile dashboard-header-tile-filled">
  <h1>
    {data?.value.name}
  </h1>
  <hr />
  <h2>All the jobs below are listed as offering "{data?.value.name}""</h2>
  <p>{data?.value?.description || ''}</p>
  {#if data.values?.hits.length === 0}
    <p>No jobs found</p>
  {:else}
    {#each data.values.hits as job (job.id)}
      <JobCarouselItem {job} profile={$profile} />
    {/each}
  {/if}
</Grid>
